import { TFunction } from '@mint-lib/i18n';

export const getAutoImportInfoStep = (t: TFunction, stepIndex: number) => {
  const autoImportInfo = [
    {
      image: 'IllustrationCreateReport',
      title: t('Import & template creation'),
      description: t(
        `Import the file manually and preserve mapping by saving the file as a template for future use.`,
      ),
    },
    {
      image: 'IllustrationEmailGeneration',
      title: t('Unique email generation'),
      description: t(
        `For each template, an auto-generated unique email is provided. Use this email to set up auto-reports directed to us for that specific template.`,
      ),
    },
    {
      image: 'IllustrationScanEmail',
      title: t('Recognition & file ingestion'),
      description: t(
        `When auto-reports arrive, our system recognizes the template and automatically injects the received file.`,
      ),
    },
    {
      image: 'IllustrationCompletion',
      title: t('Completion & process status'),
      description: t(
        `Upon completion, you will receive an email with the import process status.`,
      ),
    },
  ] as const;

  return autoImportInfo[stepIndex];
};
